import React, { useState, useEffect } from 'react';
import classes from './Login.module.css';

const SLIDES = [
  {
    id: 1,
    image: './login-img1.png',
    title: "Products With Stories You Can't See",
    description: 'Every product has a hidden journey — from materials and manufacturing to usage, ownership, and recycling. Without visibility, brands lose trust, consumers lose clarity, and sustainability loses momentum.',
    brand: 'Provinyx'
  },
  {
    id: 2,
    image: './login-img2.png',
    title: 'The Digital Passport for Every Product',
    description: 'Provinyx assigns a secure Digital Product Passport to each item, storing verified data about origin, materials, certifications, repairs, recycling, and ownership updates. Scan a QR and instantly access proof you can trust, transparent, tamper-proof, and circular by design.',
  },
  {
    id: 3,
    image: './login-img3.png',
    title: 'Transparency That Builds Trust & Circular Value',
    description: 'With Provinyx, brands unlock regulatory compliance, circular reuse, and end-of-life efficiency. Consumers gain confidence, traceability, and environmental clarity. Together, we accelerate sustainability by turning product data into proven impact.'
  }
];

const Carousel = ({ initialSlide = 0 }) => {
  const [currentSlide, setCurrentSlide] = useState(initialSlide);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      if (!isAnimating) {
        setIsAnimating(true);
        setCurrentSlide((prev) => (prev === SLIDES.length - 1 ? 0 : prev + 1));
        setTimeout(() => setIsAnimating(false), 600);
      }
    }, 15000);
    return () => clearInterval(timer);
  }, [isAnimating]);

  const handlePrevSlide = () => {
    if (currentSlide === 0 || isAnimating) return;
    setIsAnimating(true);
    setCurrentSlide((prev) => prev - 1);
    setTimeout(() => setIsAnimating(false), 600);
  };

  const handleNextSlide = () => {
    if (currentSlide === SLIDES.length - 1 || isAnimating) return;
    setIsAnimating(true);
    setCurrentSlide((prev) => prev + 1);
    setTimeout(() => setIsAnimating(false), 600);
  };

  const handleDotClick = (index) => {
    if (index === currentSlide || isAnimating) return;
    setIsAnimating(true);
    setCurrentSlide(index);
    setTimeout(() => setIsAnimating(false), 600);
  };

  return (
    <div className={classes.carouselContainer}>
      <div className={classes.slideImageWrapper}>
        {SLIDES.map((slide, index) => (
          <img
            key={slide.id}
            src={slide.image}
            alt={slide.title}
            className={`${classes.slideImage} ${index === currentSlide ? classes.active : ''}`}
          />
        ))}
      </div>

      <div className={classes.slideContent}>
        <h2 className={`${classes.slideTitle} ${classes.active}`}>
          {SLIDES[currentSlide].title}
        </h2>
        <p className={`${classes.slideDescription} ${classes.active}`}>
          {SLIDES[currentSlide].description}
        </p>
        {currentSlide === 0 && (
          <p className={`${classes.slideBrand} ${classes.active}`}>
            <em>{SLIDES[currentSlide].brand}</em> reveals what today's supply chains keep unseen.
          </p>
        )}
      </div>

      <div className={classes.carouselControls}>
        <button
          className={classes.navButton}
          onClick={handlePrevSlide}
          disabled={currentSlide === 0}
          aria-label="Previous slide"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 12H5M12 19l-7-7 7-7"/>
          </svg>
          Back
        </button>

        <div className={classes.dotsContainer}>
          {SLIDES.map((_, index) => (
            <button
              key={index}
              className={`${classes.dot} ${index === currentSlide ? classes.dotActive : ''}`}
              onClick={() => handleDotClick(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>

        <button
          className={classes.navButton}
          onClick={handleNextSlide}
          disabled={currentSlide === SLIDES.length - 1}
          aria-label="Next slide"
        >
          Next
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12h14M12 5l7 7-7 7"/>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Carousel;